import WILL_SMITH from "../../images/testimonial-will-smith.png"
import JEF_KAHN from "../../images/testimonial-jef-kahn.png"
import ROB_M from "../../images/testimonial-rob-m.png"
import GAYLE_B from "../../images/testimonial-gayle-b.png"
import KATHY_A from "../../images/testimonial-kathy-a.png"
import JOE_P from "../../images/testimonial-joe-p.png"

export const MonthlyStatementBulletPoints = [
  "Satellite-based threat monitoring",
  "Forest health and value tracking",
  "Market updates and program recommendations",
]

export const MappingBulletPoints = [
  "Loss detection for your land and neighboring parcels",
  "Satellite based info maps",
  "Detailed program information",
]

export const MemberTestimonials = [
  {
    name: "Will Smith",
    imageSrc: WILL_SMITH,
    location: "Chicago",
    acreage: 46,
    goal: "Income Generation",
    quote:
      "The NCX platform is easy to use and navigate and allowed me to compare the costs and benefits of various programs in plain, easy-to-understand language that incorporated the unique attributes of my own property.",
  },
  {
    name: "Jef Kahn",
    imageSrc: JEF_KAHN,
    location: "New York",
    acreage: 80,
    goal: "Increase Wildlife",
    quote:
      "Working with NCX was more than just about economics and helping with property taxes, which of course, is a good thing... This partnership has given me a way to stand up against the environmental challenges we're all facing.",
  },
  {
    name: "Rob M",
    imageSrc: ROB_M,
    location: "Arkansas",
    acreage: 100,
    goal: "Improve Wildlife Habitat",
    quote:
      "I've been sticking with ya'll because there are so many opportunities that change all the time. You guys seem to be on top of it and dedicated to helping us landowners achieve our goals.",
  },
  {
    name: "Gayle B",
    location: "Mississippi",
    imageSrc: GAYLE_B,
    acreage: 350,
    goal: "Keep the land in the family for generation",
    quote:
      "I was glad to have all this information in one place so that I can teach the next generation in our family about the land and what options we have to improve it and generate income in the years to come",
  },
  {
    name: "Kathy A",
    location: "Mississippi",
    imageSrc: KATHY_A,
    acreage: 150,
    goal: "Support land health & generate income",
    quote:
      "I love the property maps and how the tool shows us what is possible to do with our land",
  },
  {
    name: "Joe P",
    location: "Wisconsin",
    imageSrc: JOE_P,
    acreage: 120,
    goal: "Generate Income",
    quote:
      "You guys gave me a nice consolidated view of the programs I am eligible for.",
  },
]
